<template>
  <div class="content ht-100v pd-0">
    <div class="content-header bd-b pd-0 gosm-toolbar">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px">
        <div class="pd-l-10">Гүйцэтгэл тайлан</div>
        <div
          id="navbarSupportedContent_45963"
          class="collapse navbar-collapse order-2"
        >
          <div class="mg-l-auto">
            <a
              @click="projectEdit.show = true"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase text-white"
              ><feather type="plus"></feather> Шинэ </a
            ><!---->
          </div>
        </div>
      </nav>
    </div>
    <div class="content-body pd-0 overflow-hidden">
      <div class="row row-xs no-gutters">
        <div class="col-xs-2 col-md-2 bg-core-light">
          <vue-custom-scrollbar
            :style="`height:${scrSideHeight}px`"
            :settings="{ maxScrollbarLength: 60 }"
            class=""
          >
            <ul class="nav nav-sidebar sidebar-nav pd-t-20 nav-aside pd-l-20">
              <li class="nav-label text-break text-wrap">Төлөвлөгөө</li>
              <li class="nav-item">
                <a @click="loadReport(1)" role="button" class="nav-link"
                  ><feather type="home"></feather> Байгууллагын төлөвлөгөө
                </a>
              </li>
              <li class="nav-item">
                <a @click="loadReport(2)" role="button" class="nav-link"
                  ><feather type="users"></feather> Хэлтсийн төлөвлөгөө
                </a>
              </li>
              <li class="nav-item">
                <a @click="loadReport(3)" role="button" class="nav-link"
                  ><feather type="user"></feather> Үр дүнгийн төлөвлөгөө
                </a>
              </li>
              <li class="nav-label text-break text-wrap pd-t-20">Тайлан</li>
              <li class="nav-item">
                <a @click="loadReport(5)" role="button" class="nav-link"
                  ><feather type="home"></feather> Байгууллагын тайлан
                </a>
              </li>
              <li class="nav-item">
                <a @click="loadReport(6)" role="button" class="nav-link"
                  ><feather type="users"></feather> Хэлтсийн тайлан
                </a>
              </li>
              <li class="nav-item">
                <a @click="loadReport(66)" role="button" class="nav-link"
                  ><feather type="user"></feather> Үр дүнгийн тайлан
                </a>
              </li>
            </ul>
          </vue-custom-scrollbar>
          <div class="d-none d-md-block text-center bd-t bg-white">
            <!-- <div
              role="group"
              aria-label="Basic example"
              class="btn-group mg-y-7"
            >
              <button type="button" class="btn btn-xs btn-outline-light">
                <span>Экспорт</span></button
              ><button type="button" class="btn btn-xs btn-outline-light">
                <span>Хайх</span></button
              ><button type="button" class="btn btn-xs btn-outline-light">
                <span>Бүгд</span>
              </button>
            </div> -->
          </div>
        </div>
        <div class="col-xs-10 col-md-10 bd-l">
          <vue-custom-scrollbar
            :style="`height:${scrHeight}px`"
            :settings="{ maxScrollbarLength: 60 }"
          >
            <div class="row row-xs pd-x-10">
              <div
                class="col-sm-6 col-lg-3"
                v-for="(project, i) in projectList"
                :key="`prk_${i}`"
              >
                <div class="card pd-0">
                  <div class="card-body">
                    <div
                      role="button"
                      class="media mg-b-10"
                      @click="gotoProject(project)"
                    >
                      <div class="crypto-icon bg-secondary">
                        <feather type="briefcase"></feather>
                      </div>
                      <div class="media-body pd-l-8">
                        <h5
                          class="
                            tx-uppercase
                            tx-11
                            tx-spacing-1
                            tx-color-02
                            tx-semibold
                            mg-b-8
                          "
                        >
                          {{ project.nm }}
                          <!-- <span class="tx-color-03 tx-normal">({{ project.otName }})</span> -->
                        </h5>
                        <div class="d-flex align-items-baseline tx-rubik">
                          <h5 class="tx-20 mg-b-0">{{ project.userCount }}</h5>
                          <p class="mg-b-0 tx-11 tx-muted mg-l-3">
                            хэрэглэгч
                            <!-- <i class="icon ion-md-arrow-up"></i> 0.77% -->
                          </p>
                        </div>
                        <!-- <h6 class="card-subtitle mb-2 text-muted">
                        
                      </h6> -->
                      </div>
                    </div>
                    <p class="tx-11 tx-color-03 mg-b-0">
                      <feather type="check-square"></feather>
                      Нийт
                      <span class="tx-semibold">{{
                        project.allTaskCount
                      }}</span>
                      ажилбараас
                      <span class="tx-semibold">{{
                        project.activeTaskCount
                      }}</span
                      >-нь идэвхтэй
                    </p>
                    <p class="tx-11 tx-color-03 mg-b-0">
                      <feather type="user"></feather>
                      Надад хуваалцсан
                      <span class="tx-semibold">{{
                        project.sharedTaskCount
                      }}</span>
                      ажилбараас
                      <span class="tx-semibold">{{
                        project.pinnedTaskCount
                      }}</span
                      >-нь идэвхтэй
                    </p>
                  </div>
                  <div class="card-footer">
                    <p class="tx-11 tx-color-03 mg-b-0">
                      <feather type="clock"></feather>

                      эхлэх
                      <span class="tx-semibold">{{
                        project.startDate | moment("YYYY-MM-DD")
                      }}</span>

                      дуусах
                      <span class="tx-semibold">{{
                        project.endDate | moment("YYYY-MM-DD")
                      }}</span>
                    </p>
                    <div class="dropdown-file pd-t-5" role="button">
                      <a class="dropdown-link" data-toggle="dropdown"
                        ><feather type="more-vertical"></feather
                      ></a>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          @click="
                            projectEdit.id = project.id;
                            projectEdit.show = true;
                          "
                          data-toggle="modal"
                          class="dropdown-item details"
                          ><feather type="edit"></feather> засах</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>
    <project-edit
      :isShow="projectEdit.show"
      @on-close="
        projectEdit.show = false;
        projectEdit.id = null;
      "
      @on-updated="init()"
      :id="projectEdit.id"
    ></project-edit>
    <gov-report-drawer
      :show="govReportDrawerParams.show"
      :prmsMode="govReportDrawerParams.mode"
      :prms="govReportDrawerParams"
      :projectTag="projectTag"
      @set-rpt-mode="listByGovRpt"
      @on-drawer-close="
        govReportDrawerClose();
        filterMode = 0;
      "
    ></gov-report-drawer>
  </div>
</template>

<script>
import { request } from "@/api/all";
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    vueCustomScrollbar,
    govReportDrawer: () => ({
      component: import("@/views/apps/work/project/component/planReport"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 300,
      timeout: 5000,
    }),
    projectEdit: () => ({
      component: import("@/views/apps/work/project/projectEdit"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      projectList: [],
      allProjectCount: 0,
      scrHeight: 0,
      scrSideHeight: 600,
      projectEdit: {
        show: false,
        id: null,
      },
      govReportDrawerParams: {
        projectId: 0,
        mode: 0,
        mainProjectOt: 0,
        show: false,
      },
      projectTag: 0,
    };
  },
  mounted() {
    this.projectTag = this.$route.meta.tag;
    this.projectTag = 1;
    this.init();
    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowHeight);
      this.getWindowHeight();
    });

    //console.log(moment().startOf('quarter'));
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    gotoProject(e) {
      //console.log(e);
      this.$router.push({
        name: "workTasks",
        params: {
          projectId: e.id,
          ot: 1,
          edit: 0,
          detail: 0,
        },
      });
    },
    getWindowHeight() {
      let minusHeight = 59;
      this.scrHeight = window.innerHeight - minusHeight;
      let extraSide = 104;
      this.scrSideHeight = window.innerHeight - extraSide;
    },
    init() {
      request({
        api: { method: "GET", url: "task/GetSharedTaskProjects" },
        params: {
          tag: this.projectTag,
        },
        store: this.$store,
      }).then((res) => {
        this.projectList = res.list;
        this.allProjectCount = res.list.length;
      });
    },
    loadReport(mode) {
      this.listByGovRpt(mode);
    },
    listByGovRpt(e) {
      //console.log("step 3", e);
      this.govReportDrawerParams.projectId = this.projectId;
      this.govReportDrawerParams.mainProjectOt = this.objectTypeId;

      this.govReportDrawerParams.mode = e;
      this.govReportDrawerParams.show = true;
    },
    govReportDrawerClose() {
      this.govReportDrawerParams.mode = 0;
      this.govReportDrawerParams.show = false;
    },
  },
};
</script>
<style>
.crypto-icon {
  width: 42px;
  height: 42px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>